export enum PortabilityRequestSteps {
  Information = 'Information',
  Conclusion = 'Conclusion'
}
